<div class="overview" dir="rtl">
  <div *ngIf="loading" class="empty-box">
    <i class="fa fa-spinner fa-spin"></i>
    <span>در حال دریافت اطلاعات ناوگان...</span>
  </div>

  <div *ngIf="!loading && !hasData" class="empty-box">
    <i class="fa fa-car"></i>
    <span>داده‌ای برای نمایش وجود ندارد</span>
  </div>

  <ng-container *ngIf="!loading && hasData">
    <!-- KPI's -->
    <section class="kpis">
      <div class="kpi" *ngFor="let k of kpis; trackBy: trackByKpi" [ngClass]="k.cls">
        <div class="t"><i class="fa {{ k.icon }}"></i> {{ k.title }}</div>
        <div class="v">{{ k.value }}</div>
        <div class="d">{{ k.desc }}</div>
      </div>
    </section>

    <!-- Stats-->
    <div class="stat-strip">
      <div class="risk" *ngFor="let r of riskStrip">
        <b [ngClass]="riskClass(r.value)">{{ toEn(r.value) }}</b>
        <span>{{ r.label }}</span>
      </div>
    </div>

    <!-- charts -->
    <div class="grid-3">
      <div class="box">
        <h3><i class="fa fa-pie-chart"></i> توزیع وضعیت ایمنی</h3>
        <div class="chart"><canvas id="safetyDonut"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-exclamation-triangle"></i> 10 خودروی بحرانی (کمترین امتیاز ایمنی)</h3>
        <div class="chart"><canvas id="safetyTop10"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-crosshairs"></i> میانگین مؤلفه‌های ریسک</h3>
        <div class="chart"><canvas id="safetyRadar"></canvas></div>
      </div>
    </div>

    <!-- charts -->
    <div class="grid-2">
      <div class="box">
        <h3><i class="fa fa-dot-circle-o"></i> پراکندگی: مسافت پیموده‌شده vs امتیاز ایمنی</h3>
        <div class="chart-lg"><canvas id="safetyScatter"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-bar-chart"></i> نرخ رویداد در هر 50 کیلومتر (میانگین ناوگان)</h3>
        <div class="chart-lg"><canvas id="safetyPer50"></canvas></div>
      </div>
    </div>

  </ng-container>
</div>
